var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isGray ? 'isGray' : '',attrs:{"id":"app"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }